<script>
    import {createEventDispatcher} from 'svelte/internal';
    import EmbeddedIcon from "../icons/EmbeddedIcon.svelte";

    export let name = null;
    export let label = '';
    export let value = null;
    export let title = '';
    export let cssClass = '';
    export let checked = 0;
    export let disabled = false;
    export let editable = true;
    export let hideOverflow = null;
    export let inline = false;
    export let spaceTopLg = false;
    export let spaceTopMd = false;
    export let spaceTopSm = false;

    const dispatch = createEventDispatcher();

    export const isChecked = () => {
        return checked;
    }

    const onClick = () => {
        if (!disabled && editable) {
            checked = !checked;
            dispatch('change', {name, value, checked});
        }
    }

    $: checked = ~~checked;
</script>

<div class="checkbox-control {cssClass}"
     class:inline={inline}
     class:space-top-lg={spaceTopLg}
     class:space-top-md={spaceTopMd}
     class:space-top-sm={spaceTopSm}
     class:disabled="{ disabled }"
     title="{ title }"
     on:click|stopPropagation="{ onClick }">
    <div class="content">
        <div class="icon" class:checked={ checked }>
            {#if checked }
                <div class="icon-inner">
                    <EmbeddedIcon icon="check" size="9" strokeWidth="5"/>
                </div>
            {/if}
        </div>
        <div class="label" class:hide-overflow={ hideOverflow }>{ label }</div>
    </div>
</div>

<style>
    .checkbox-control {
    }
    .checkbox-control.inline {
        display: inline-block;
    }

    @media (min-width: 577px) and (max-width: 767px) {
        .checkbox-control.space-top-sm {
            margin-top: 23px;
        }
    }

    @media (min-width: 768px) and (max-width: 991px) {
        .checkbox-control.space-top-md {
            margin-top: 23px;
        }
    }

    @media (min-width: 992px) {
        .checkbox-control.space-top-lg {
            margin-top: 36px;
        }
    }

    .content {
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    .icon {
        position: relative;
        width: 16px;
        height: 16px;
        color: #fff;
        border: var(--default-border);
        border-radius: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
    }

    .icon.checked {
        background: #03a9f4;
        border-color: #03a9f4;
    }

    .icon .icon-inner {
        margin-top: -3px;
    }

    .label {
        width: calc(100% - 16px);
        line-height: 1;
        padding-left: 5px;
    }

    /*.checkbox-control:hover .content .label {*/
    /*    color: #000;*/
    /*}*/

    .checkbox-control.disabled .content {
        cursor: not-allowed;
    }

    .checkbox-control.disabled .label, .checkbox-control.disabled .icon {
        color: #888 !important;
    }

    .hide-overflow {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    /*:global(.inline + .inline) {*/
    /*    !*margin-top: 0;*!*/
    /*    margin-left: 10px;*/
    /*}*/
    :global(.checkbox-control.inline:last-child) {
        margin-right: 0 !important;
    }
</style>